import { createAction } from 'redux-actions';
import * as types from '../constants/actionTypes/session';

export const setSession = createAction(types.SET_SESSION);
export const setLoading = createAction(types.SET_LOADING);
export const updateAuthorization = createAction(types.UPDATE_AUTHORIZATION, (authorization) => ({ authorization }));
